import { AlertColor } from "@mui/material";
import { proxy } from "valtio";

export interface IToastEntry {
    id: string;
    status: AlertColor;
    title: string;
    buttonText?: string;
    duration: number;
    onCloseCallback?(): void;
}

export type IToastInput = Omit<IToastEntry, "id">;

export const toastStore = proxy({
    toasts: [] as IToastEntry[],

    push(entry: IToastInput): string {
        const id = crypto.randomUUID();
        toastStore.toasts.unshift({ ...entry, id });

        return id;
    },

    remove(id: string) {
        const index = toastStore.toasts.findIndex(item => item.id === id);
        if (index !== -1) {
            toastStore.toasts.splice(index, 1);
        }
    },
});
